import { PaymentMethod } from 'models'
import { UfinityProduct } from 'services/ufinity/models'
import CommonApi from 'services/common'
import ConfigHelper from 'framework/helpers/config'
import Constants from 'api-constants'

/**
 * Update entitlements into Products
 * @return {Object} data raw data from the backend
 * @param {Array<Subscription>} products  Subscriptions
 */
export const filterProductOffers = (products = []) => {
    const userPaymentMethods = CommonApi.getInstance().getPaymentMethodsTypes()
    const { platform = Constants.platform.androidTvStb } = ConfigHelper.getInstance().getConfig()

    const {
        enabledSubscriptionsProductTypesSTB = [
            UfinityProduct.PRODUCT_TYPE.LIGER,
            UfinityProduct.PRODUCT_TYPE.APPS,
        ],
        enabledSubscriptionsProductTypesOpenDevice = [UfinityProduct.PRODUCT_TYPE.INTERNET],
        enabledTvodProductTypes = [UfinityProduct.PRODUCT_TYPE.TVOD],
        oneTypeChargeProductTypes = [UfinityProduct.PRODUCT_TYPE.PPV],
    } = ConfigHelper.getInstance().getConfig('ufinity')

    const enabledSubscriptionsProductTypes =
        platform === Constants.platform.androidTvStb
            ? enabledSubscriptionsProductTypesSTB
            : enabledSubscriptionsProductTypesOpenDevice

    return (products || []).reduce((acc, product) => {
        if (product && product.id) {
            if (product.isSubscription && product.isSubscription()) {
                // According to Starhub, Only 'LIGER' pack can be purchased inside the TV APP.
                // Other type of pack can be purchased through the web site
                // TODO FOR Mobile Handle IAP properly with a Ufinied devices property
                let offers = (product.offers || [])
                    .filter((x) =>
                        userPaymentMethods.includes(PaymentMethod.PAYMENT_METHOD_TYPE.PAY_ON_BILL)
                            ? enabledSubscriptionsProductTypes.includes(x.offerType)
                            : true
                    )
                    .map((offer) => {
                        if (
                            oneTypeChargeProductTypes.includes(offer.offerType) &&
                            offer.oneTimeCharge === undefined
                        ) {
                            return offer.update({
                                oneTimeCharge: true,
                            })
                        }
                        return offer
                    })
                    .filter(Boolean)
                acc.push(
                    product.update({
                        offers,
                    })
                )
            } else if (product.isTVOD && product.isTVOD()) {
                acc.push(
                    product.update({
                        offers: (product.offers || []).filter((x) =>
                            enabledTvodProductTypes.includes(x.offerType)
                        ),
                    })
                )
            }
        }
        return acc
    }, [])
}
